module.exports = "/packs/media/images/Retirement-ed9dd0bbd1065e3db3632e84c1475649.png";